export default {
    get<T>(name: string) {
        const s = window.localStorage.getItem(name);

        if (!s) {
            return;
        }

        return JSON.parse(s) as T;
    },

    set<T>(name: string, v: T) {
        if (!v) {
            return;
        }

        window.localStorage.setItem(name, JSON.stringify(v));
    },

    cache<T = string>(cacheName: string, key: string, value?: string): T {
        let cache = {};
        const storedCache = window.localStorage.getItem(cacheName);

        if (storedCache) {
            cache = JSON.parse(storedCache);
        }

        if (value) {
            cache[key] = value;
            window.localStorage.setItem(cacheName, JSON.stringify(cache));

            return value as T;
        } else {
            return cache[key] as T;
        }
    },

    delete(name: string) {
        window.localStorage.removeItem(name);
    },
};
